import { useEffect } from 'react'
import parse from 'html-react-parser'
import { X } from 'lucide-react'

import { AdasBox, AdasTypography, AdasButton } from '@components/wrapper-components'
import { InfoPopover } from '@components/popover'
import './broadcastBar.css'
import { useNotificationSubscription } from '@hooks'
import { useCenterStore } from '@caradasstore/CenterStore'
import { useBroadcastStore } from '@caradasstore/BroadcastStore'
import { getActiveBroadcast } from 'api/api'
import { htmlParseOptions } from '../../utils/utils'

export const BroadcastBar = () => {
  const centerDetail = useCenterStore((store) => store.centerDetail)
  const broadcastmessage = useBroadcastStore((store) => store.broadCastMessage)
  const setBroadcastMessage = useBroadcastStore((store) => store.setBroadcastMessage)

  useNotificationSubscription(centerDetail?.id)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const broadcastResponse = await getActiveBroadcast()
        if (broadcastResponse?.data) {
          setBroadcastMessage(broadcastResponse.data)
        } else {
          setBroadcastMessage(null)
        }
      } catch (error) {
        console.log(error)
      }
    }

    fetchData()
  }, [])

  const clearBroadcastMessage = () => setBroadcastMessage(null)

  return (
    broadcastmessage?.message && (
      // Same column as the page content (and the billing status bar), so it lines up with the page below.
      <AdasBox className='px-3 min-[435px]:px-6 mx-auto w-full max-w-[1400px] mt-4'>
        <AdasBox className={`notification-message-section ${broadcastmessage.type === 'CRITICAL' ? 'critical' : ''}`}>
          <AdasBox className='notification-message-content-title'>
            <InfoPopover
              iconColor={broadcastmessage.type === 'CRITICAL' ? '#D22A23' : '#001B3F'}
              ariaLabel='Information on default'
              enableClick={false}
            />
            <AdasTypography className='notification-subject'>{broadcastmessage.subject}</AdasTypography>
            <AdasButton
              buttonType='iconButton'
              className='text-info cursor-pointer p-0.5'
              aria-label='Dismiss announcement'
              onClick={clearBroadcastMessage}
            >
              <X className='w-4 h-4' />
            </AdasButton>
          </AdasBox>
          <AdasBox className='notification-message'>{parse(broadcastmessage.message, htmlParseOptions)}</AdasBox>
        </AdasBox>
      </AdasBox>
    )
  )
}
